// extracted by mini-css-extract-plugin
module.exports = {"answer":"style_answer__1C04H","border-bottom":"style_border-bottom__KXwZf","border":"style_border__InTP3","plus":"style_plus__C_56L","minus":"style_minus__U20G1"};